module.exports = __webpack_public_path__ + "img/nexa_img.bb5e5369.svg";